import { render, staticRenderFns } from "./campaigns-input-region-instance.vue?vue&type=template&id=4bed75c8&"
import script from "./campaigns-input-region-instance.vue?vue&type=script&lang=js&"
export * from "./campaigns-input-region-instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports